var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvidingLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_51702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4445 56.9596C57.4445 50.6834 56.9645 44.3581 57.5676 38.1434C58.2815 30.9074 65.0633 25.1235 72.362 25.0743C92.1167 24.9389 111.859 25.0251 131.614 25.0251C131.712 25.0251 131.823 25.0743 132.143 25.1604V26.871C132.143 34.9561 132.143 43.0536 132.143 51.1388C132.155 60.9591 139.072 67.8383 148.919 67.8506C156.956 67.8629 164.981 67.8506 173.018 67.8506C173.622 67.8506 174.225 67.8506 174.988 67.8506V69.4504C174.988 99.0713 174.988 128.692 174.988 158.313C174.988 166.189 170.421 172.379 163.11 174.373C161.732 174.754 160.255 174.951 158.827 174.951C135.725 174.988 112.634 174.976 89.532 174.976C89.1996 174.976 88.8673 174.939 88.9535 174.951C89.0643 170.115 89.2366 165.352 89.2612 160.59C89.3104 150.265 89.2612 139.952 89.3104 129.628C89.3104 128.828 89.6427 127.868 90.1351 127.24C110.567 101.803 97.3231 64.6879 65.3464 57.981C62.737 57.4395 60.0538 57.2796 57.4199 56.9473L57.4445 56.9596ZM126.85 148.21C133.94 148.21 141.017 148.235 148.107 148.21C151.233 148.198 153.584 145.835 153.572 142.844C153.572 139.866 151.208 137.516 148.07 137.516C133.903 137.491 119.724 137.516 105.557 137.516C103.489 137.516 101.865 138.353 100.794 140.112C99.7601 141.811 99.6862 143.607 100.646 145.367C101.705 147.287 103.379 148.235 105.582 148.235C112.671 148.235 119.749 148.235 126.838 148.235L126.85 148.21ZM132.155 83.9347C126.961 83.9347 121.779 83.9347 116.585 83.9347C113.151 83.9347 110.751 86.1375 110.727 89.2387C110.702 92.3399 113.114 94.6288 116.499 94.6411C126.937 94.6534 137.362 94.6534 147.799 94.6411C151.184 94.6411 153.596 92.3522 153.572 89.251C153.547 86.1622 151.134 83.947 147.713 83.9347C142.519 83.9224 137.337 83.9347 132.143 83.9347H132.155ZM132.241 110.713C127.047 110.713 121.866 110.713 116.672 110.713C113.127 110.713 110.714 112.928 110.727 116.103C110.751 119.192 113.164 121.419 116.585 121.419C126.961 121.419 137.337 121.419 147.713 121.419C151.134 121.419 153.547 119.204 153.572 116.115C153.596 112.953 151.159 110.725 147.627 110.713C142.494 110.713 137.362 110.713 132.229 110.713H132.241ZM107.994 67.8629C110.554 67.8629 113.127 67.8752 115.687 67.8629C119.059 67.8383 121.472 65.5493 121.435 62.4481C121.398 59.4208 119.01 57.1811 115.724 57.1688C110.591 57.1442 105.459 57.1442 100.326 57.1688C97.0523 57.1811 94.6768 59.4454 94.6645 62.4974C94.6645 65.537 97.04 67.8383 100.289 67.8629C102.849 67.8875 105.422 67.8629 107.982 67.8629H107.994Z",
    fill: "url(#paint0_linear_118_51702)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2857 99.9691C89.2857 117.702 74.8974 132.125 57.1613 132.125C39.4252 132.137 25 117.739 25 100.018C25 82.2851 39.3883 67.8746 57.1244 67.8623C74.8728 67.8623 89.2734 82.2482 89.2857 99.9814V99.9691Z",
    fill: "url(#paint1_linear_118_51702)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5653 137.146V138.808C78.5653 148.788 78.5653 158.781 78.5653 168.761C78.5653 171.801 77.4452 173.72 75.0451 174.619C72.5096 175.566 70.5403 174.606 68.7433 172.785C64.9401 168.933 61.0753 165.155 57.1244 161.23C56.7551 161.574 56.349 161.919 55.9674 162.3C52.4226 165.857 48.8902 169.413 45.3331 172.957C43.3146 174.976 41.1853 175.517 38.9821 174.52C36.6312 173.462 35.6958 171.53 35.6958 169.007C35.7204 158.473 35.6958 147.927 35.6958 137.159C49.9364 144.715 64.1154 144.776 78.5529 137.159L78.5653 137.146Z",
    fill: "url(#paint2_linear_118_51702)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.912 28.7285C152.365 38.1674 161.806 47.6062 171.246 57.0327C171.074 57.045 170.68 57.1312 170.274 57.1312C163.073 57.1312 155.885 57.1435 148.685 57.1312C145.202 57.1312 142.9 54.953 142.876 51.6057C142.839 44.1851 142.876 36.7644 142.876 29.3561C142.876 29.0977 142.912 28.8393 142.925 28.7285H142.912Z",
    fill: "url(#paint3_linear_118_51702)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_51702",
    x1: 116.126,
    y1: 24.998,
    x2: 116.126,
    y2: 174.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_51702",
    x1: 57.1429,
    y1: 67.8623,
    x2: 57.1429,
    y2: 132.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_51702",
    x1: 57.1305,
    y1: 137.146,
    x2: 57.1305,
    y2: 175.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_51702",
    x1: 157.053,
    y1: 28.7285,
    x2: 157.053,
    y2: 57.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_51702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvidingLicense);
export default __webpack_public_path__ + "static/media/Providing-license.11230d9c4c5e42b71a7b1345fe8d7506.svg";
export { ForwardRef as ReactComponent };